const BAND_ORDER = ['K-2', '3-5', '6-8', '9-12']

const gradeToBand = (grade: string): string => {
	const g = grade.trim().toUpperCase()
	if (g === 'K' || g === '1' || g === '2') return 'K-2'
	if (g === '3' || g === '4' || g === '5') return '3-5'
	if (g === '6' || g === '7' || g === '8') return '6-8'
	if (g === '9' || g === '10' || g === '11' || g === '12' || g === 'T') return '9-12'
	return '3-5'
}

/**
 * Derive a lesson's grade band from a class's grade list. `T` (Transition,
 * 18+) bands to 9-12 -- it was previously missing from two of the three
 * independent copies of this function, so classes with a Transition grade
 * silently fell back to the 3-5 default depending on which screen touched
 * them. One definition now, shared by upload, assign, and copy/reassign.
 */
export const deriveGradeBand = (grades: string[] | undefined | null): string => {
	if (!grades || grades.length === 0) return '3-5'

	const bands = grades.map(gradeToBand)
	const uniqueBands = Array.from(new Set(bands))

	// If grades span multiple bands, use the lowest one.
	return uniqueBands.sort((a, b) => BAND_ORDER.indexOf(a) - BAND_ORDER.indexOf(b))[0]
}

/**
 * A grade code as a short display label -- 'k' -> 'K', '5' -> 'Gr 5',
 * 't' -> '18+' (Transition). Same code family deriveGradeBand reads, kept
 * here so a class's grade chips and its band derivation never drift on
 * what the codes mean.
 */
export const shortGrade = (grade: string): string => {
	const g = grade.trim().toUpperCase()
	if (g === 'K') return 'K'
	if (g === 'T') return '18+'
	return g ? `Gr ${g}` : g
}
